import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { CarService } from 'src/app/services/car/car.service';
import { GeneralService } from 'src/app/services/general/general.service';
import { VehicleModalService } from 'src/app/services/vehicle-modal/vehicle-modal.service';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-vh-manager-update',
  templateUrl: './vh-manager-update.component.html',
  styleUrls: ['./vh-manager-update.component.scss']
})
export class VhManagerUpdateComponent extends DestructorComponent implements OnInit {

  @Output() vehicleUpdated = new EventEmitter<void>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  vehicleForm: FormGroup;
  isLoading: boolean = false;
  selectedVehicle: any = null;
  yardsList: any[] = [];
  selectedFile: File | null = null;
  fileUrl: string = '';

  constructor(
    private fb: FormBuilder,
    private _carService: CarService,
    private _generalService: GeneralService,
    private _vehicleModalService: VehicleModalService
  ) {
    super();
    this.initializeForm();
  }

  ngOnInit(): void {
    this.setupModalListener();
    this.loadYards();
  }

  private loadYards(): void {
    this.subscriptions.push(
      this._generalService.GetYards().subscribe({
        next: (response: any) => {
          if (response.status && response.data) {
            this.yardsList = response.data.map((yard: any) => ({
              value: yard.slug || yard._id,
              label: yard.name
            }));
          }
        },
        error: (error: any) => {
          console.error('Error loading yards:', error);
        }
      })
    );
  }

  private initializeForm(): void {
    this.vehicleForm = this.fb.group({
      // Basic Info - Disabled
      car_no: [{ value: '', disabled: true }],
      inventory_no: [{ value: '', disabled: true }],
      name: [{ value: '', disabled: true }],
      company_name: [{ value: '', disabled: true }],
      year: [{ value: '', disabled: true }],
      mileage: [{ value: '', disabled: true }],
      fuel_type: [{ value: '', disabled: true }],
      transmission: [{ value: '', disabled: true }],
      doors: [{ value: '', disabled: true }],
      color: [{ value: '', disabled: true }],
      vin_no: [{ value: '', disabled: true }],
      location: [{ value: '', disabled: true }],
      price: [{ value: '', disabled: true }],
      engine: [{ value: '', disabled: true }],

      // Editable fields
      yard: [''],
      yard_date: [''],
      bl_docs: [null]
    });
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_vehicle_update');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        const serviceVehicle = this._vehicleModalService.getSelectedVehicle();
        if (serviceVehicle) {
          this.selectedVehicle = serviceVehicle;
          this.populateForm(this.selectedVehicle);
        } else {
          this.resetForm();
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this._vehicleModalService.clearSelectedVehicle();
        this.resetForm();
      });
    }
  }

  private populateForm(vehicle: any): void {
    this.vehicleForm.patchValue({
      car_no: vehicle.car_no || '',
      inventory_no: vehicle.inventory_no || '',
      name: vehicle.name || '',
      company_name: vehicle.company_name || '',
      year: vehicle.year || '',
      mileage: vehicle.mileage || '',
      fuel_type: vehicle.fuel_type || '',
      transmission: vehicle.transmission || '',
      doors: vehicle.doors || '',
      color: vehicle.color || '',
      vin_no: vehicle.vin_no || '',
      location: vehicle.location || '',
      price: vehicle.price || '',
      engine: vehicle.engine || '',
      yard: vehicle.yard || '',
      yard_date: vehicle.yard_date || ''
    });

    this.fileUrl = vehicle.bl_docs || '';
  }

  private resetForm(): void {
    this.vehicleForm.reset();
    this.selectedVehicle = null;
    this.selectedFile = null;
    this.fileUrl = '';
    this.isLoading = false;

    // Reset file input
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.uploadFile(file);

    }
  }

  uploadFile(file: any) {

    this._generalService.uploadFileByContent({ "contentType": file.type }).subscribe(res => {

      console.log('res-->', res)
      const imageUrl = res.data.url;
      let formData = this._generalService.convertKeysToFormdata(res.data.result.fields, file);


      this._generalService.sendFileToS3(res.data.result.url, formData).subscribe(res => {

        this.vehicleForm.patchValue({ bl_docs: imageUrl });

        this.fileUrl = imageUrl;

      })

    })
  }

  openFile(): void {
    if (this.fileUrl) {
      window.open(this.fileUrl, '_blank');
    }
  }

  onSubmit(): void {
    if (this.vehicleForm.invalid || !this.selectedVehicle) {
      return;
    }

    this.isLoading = true;

    // Prepare form data for update
    // const formData = {};

    // Only send editable fields
    const yardValue = this.vehicleForm.get('yard')?.value;
    // if (yardValue) {
    //   formData.append('yard', yardValue);
    // }

    // const yardDateValue = this.vehicleForm.get('yard_date')?.value;
    // if (yardDateValue) {
    //   formData.append('yard_date', yardDateValue);
    // }

    // if (this.selectedFile) {
    //   formData.append('bl_docs', this.selectedFile);
    // }

    let formData = {
      yard_id: yardValue,
      yard_date: this.vehicleForm.get('yard_date')?.value,
      bl_docs: this.vehicleForm.get('bl_docs')?.value
    }

    this.subscriptions.push(
      this._carService.UpdateData(this.selectedVehicle._id, formData).subscribe({
        next: (response: any) => {
          if (response.status) {
            Swal.fire({
              title: 'Success!',
              text: 'Vehicle updated successfully',
              icon: 'success',
              confirmButtonText: 'OK'
            });
            this.vehicleUpdated.emit();
            this.closeModal();
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.message || 'Failed to update vehicle',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error updating vehicle:', error);
          Swal.fire({
            title: 'Error!',
            text: 'Failed to update vehicle',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          this.isLoading = false;
        }
      })
    );
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_vehicle_update');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
      this.resetForm();
    }
  }

  // Getters for form controls
  get yard() { return this.vehicleForm.get('yard'); }
  get bl_docs() { return this.vehicleForm.get('bl_docs'); }
}
